import { BottomButtonsLayout, theme } from 'aimo-ui';
import CorporateAccountItem from 'components/account/companyBenefits/CorporateAccountItem';
import EmptyView from 'components/account/companyBenefits/EmptyView';
import CustomCarousel from 'components/common/CustomCarousel';
import { MarginView } from 'components/park/styles/styles';
import FlatListCustom from 'components/sheets/FlatListCustom';
import AccountContext from 'context/AccountContext';
import React, { useContext } from 'react';
import { ScrollView } from 'react-native';
import { SheetDetailsWrapper, StyledWrapper } from 'styles/ContainerStyles';
import { isWeb } from 'utils/deviceUtils';

const CorporateAccount: React.FC = () => {
  const {
    customer: { companyBenefits },
  } = useContext(AccountContext);

  if (!companyBenefits || companyBenefits.length < 1) {
    return <EmptyView />;
  }

  return (
    <ScrollView>
      <SheetDetailsWrapper pt={isWeb ? 60 : 0}>
        <BottomButtonsLayout
          scrollable={false}
          contentBottom={
            <StyledWrapper center maxWidth={600}>
              {/* <Button
              size="l"
              onPress={() => null}
              text={t('button.companyPermit')}
              buttonType="secondary"
              testID="company-permit-add-new"
              iconComponent={ArrowIcon}
              iconRight
            /> */}
            </StyledWrapper>
          }>
          {isWeb ? (
            <FlatListCustom
              data={companyBenefits}
              removeClippedSubviews={false}
              renderItem={({ item, index }) =>
                CorporateAccountItem(item, index)
              }
              ListFooterComponent={() => <MarginView />}
              keyExtractor={(item, index) => `${item?.uid}-${index}`}
            />
          ) : (
            <StyledWrapper center>
              <CustomCarousel
                carouselData={companyBenefits as any[]}
                width={theme.normalising.widthPixel(340)}
                height={theme.normalising.heightPixel(480)}
                enabled={(companyBenefits || []).length > 1}
                carouselItem={(item, index) =>
                  CorporateAccountItem(item, index)
                }
              />
            </StyledWrapper>
          )}
        </BottomButtonsLayout>
      </SheetDetailsWrapper>
    </ScrollView>
  );
};

export default CorporateAccount;
